export function getSafely(data, path) {
  const len = path.length;
  for (
    let i = 0;
    typeof data === 'object' && data !== null && i < len;
    i += 1
  ) {
    // eslint-disable-next-line no-param-reassign
    data = data[path[i]];
  }
  return data;
}

export function findById(arrayToSearch, attrValToFind, attrName) {
  // eslint-disable-next-line
  attrName = typeof attrName !== 'undefined' ? attrName : 'id';
  if (!arrayToSearch) {
    return null;
  }
  const arr = $.grep(arrayToSearch, (entry) => {
    return entry[attrName] == attrValToFind;
  });
  if (arr && arr.length) {
    return arr[0];
  }

  return null;
}
